module.exports = __webpack_public_path__ + "img/fi-toasts-1200x790.9b20238b.jpg";